
export class PlateValidator {

  static isValidPlate(plate: string): boolean {
    const plateRegex = [
      /^[A-Za-z]{1,2}\d{6}$/,
      /^[A-Za-z]{1,2}\d{4}[A-Za-z]{1,2}$/,
      /^\d{4}([A-Za-z]){3}$/,
      /^[cC]\d{4}([A-Za-z]){3}$/,
      /^[H]{1}\d{4}([A-Za-z]){3}$/,
    ];

    return plateRegex.some(rx => rx.test(plate));
  }

}
